<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <mat-card appearance="outlined">
        <div class="row message">
          <div class="col-12 text-center">
            <!--
              A recipient who had already participated re-enters through the same route as one who
              has just finished (FR-023), so the wording is what tells them apart. Before this, a
              re-entry matched neither branch below and the screen rendered no title at all.
            -->
            <div *ngIf="isAlreadyParticipated; else completionWording">
              <h2>{{ 'HTTP.ERRORS.ALREADY_PARTICIPATED.TITLE' | translate }}</h2>
              <h4>{{ 'HTTP.ERRORS.ALREADY_PARTICIPATED.SUBTITLE' | translate }}</h4>
            </div>

            <!-- The completion path, unchanged: same branches, same markup, same wording. -->
            <ng-template #completionWording>
              <div *ngIf="errorCode === null">
                <h2>{{ 'HTTP.ERRORS.SIGNED.TITLE' | translate }}</h2>
                <h4>{{ errorMessage }}</h4>
              </div>

              <div *ngIf="errorCode === 0">
                <h2>{{ errorMessage }}</h2>
              </div>
            </ng-template>

            <h4>
              {{ 'HTTP.ERRORS.SIGNED.INVITATION' | translate }}
              <a [href]="link">{{
                'HTTP.ERRORS.SIGNED.COMPANY' | translate
              }}</a>
            </h4>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
